import { render, staticRenderFns } from "./AllMyLikedDishes.vue?vue&type=template&id=95c68d90&scoped=true"
import script from "./AllMyLikedDishes.vue?vue&type=script&lang=js"
export * from "./AllMyLikedDishes.vue?vue&type=script&lang=js"
import style0 from "./AllMyLikedDishes.vue?vue&type=style&index=0&id=95c68d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c68d90",
  null
  
)

export default component.exports